import React from 'react';
import MemberLayout from '../../components/MemberLayout';
import { useGroup } from '../../context/AuthContext';

export default function Privacy() {
  const { group } = useGroup();
  const name = group?.name || 'the group';
  return (
    <MemberLayout>
      <article className="card mx-auto max-w-3xl p-7 md:p-10">
        <h1 className="font-display text-4xl font-bold text-navy-900">Privacy &amp; consent</h1>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-gray-700">
          <p>{name} collects your details only so the committee can reach members quickly with AGM news, events, school projects and other group communication.</p>
          <h2 className="pt-2 text-lg font-semibold text-navy-900">What we store</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>Your name, class, email address and mobile number</li>
            <li>Your NIC number (used to read your date of birth for birthday wishes)</li>
            <li>Your RCU membership card number, registered date and a photo of the card (to confirm membership)</li>
            <li>Optional details: city / country and profession</li>
          </ul>
          <h2 className="pt-2 text-lg font-semibold text-navy-900">Who can see it</h2>
          <p>Only appointed admins can see contact details, NIC numbers and RCU card images. Members see only their own details. Your information is never shared or sold.</p>
          <h2 className="pt-2 text-lg font-semibold text-navy-900">Your choices</h2>
          <ul className="list-disc space-y-1 pl-5">
            <li>Choose which emails you receive from your profile, or unsubscribe using the link in any email.</li>
            <li>Update your details at any time. Once a year we'll ask you to confirm they are still correct.</li>
            <li>Ask for your data to be deleted from the Privacy tab of your profile.</li>
          </ul>
          <p className="pt-2">We follow Sri Lanka's Personal Data Protection Act, No. 9 of 2022.</p>
        </div>
      </article>
    </MemberLayout>
  );
}
